import { fmt, fmtDate } from '@dcc-erp/shared';
import type { PettyCashCount } from '@dcc-erp/shared';

import { CountCloseStatusBadge, diffColor } from './pc-helpers';

// ─── Cash-count section (PCC) — periodic counts list + approval trigger ──────
export function PCCountsSection({
  counts,
  onOpenApproval,
}: {
  counts: readonly PettyCashCount[];
  onOpenApproval: (count: PettyCashCount) => void;
}) {
  return (
    <div className="tbl-shell" style={{ marginTop: 16 }}>
      <div className="filter-row">
        <span style={{ fontWeight: 600, fontSize: 14 }}>การนับเงินสด (Cash Count)</span>
        <span className="muted" style={{ fontSize: 13 }}>
          ผลต่าง = นับได้ − ยอดในบัญชี · อนุมัติแล้วลง JV ส่วนเกิน/ขาด
        </span>
        <div style={{ marginLeft: 'auto' }}>
          <span className="meta">แสดง {counts.length} รายการ</span>
        </div>
      </div>
      <div className="tbl-wrap" style={{ maxHeight: 320 }}>
        <table className="tbl">
          <thead>
            <tr>
              <th>เลขที่</th>
              <th>วันที่นับ</th>
              <th className="num">ยอดในบัญชี</th>
              <th className="num">นับได้จริง</th>
              <th className="num">ผลต่าง</th>
              <th>สถานะ</th>
              <th style={{ width: 90 }} />
            </tr>
          </thead>
          <tbody>
            {counts.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  style={{ textAlign: 'center', padding: 28, color: 'var(--text-muted)' }}
                >
                  ยังไม่มีการนับเงินสดของ float นี้
                </td>
              </tr>
            ) : (
              counts.map((c) => {
                const diff = Number(c.difference);
                return (
                  <tr key={c.id}>
                    <td className="code" style={{ color: 'var(--brand)', fontWeight: 500 }}>
                      {c.voucherNo}
                    </td>
                    <td>{fmtDate(c.countDate)}</td>
                    <td className="num tnum">{fmt(Number(c.expectedBalance))}</td>
                    <td className="num tnum">{fmt(Number(c.countedBalance))}</td>
                    <td className="num tnum" style={{ color: diffColor(diff), fontWeight: 600 }}>
                      {diff > 0 ? '+' : ''}
                      {fmt(diff)}
                    </td>
                    <td>
                      <CountCloseStatusBadge status={c.status} approvalStatus={c.approvalStatus} />
                    </td>
                    <td>
                      <button
                        type="button"
                        className="btn sm ghost"
                        data-testid={`pc-open-count-approval-${c.id}`}
                        style={{ fontSize: 12, height: 22, padding: '0 6px' }}
                        onClick={() => onOpenApproval(c)}
                        title="ดูสายอนุมัติ"
                      >
                        สายอนุมัติ
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
